import type { PageBuilderButtonStore } from '@fhs/cms-groq-queries';

import { ActionHandler, PageBuilderLinkAction } from '../../types';
import { ActionLink } from '../action-link';

import { hrefByPlatform } from './constants';
import { SvgAppStore } from './svgs/app-store';
import { SvgGooglePlay } from './svgs/google-play';

export type AppStoreButtonProps = Pick<PageBuilderButtonStore, 'platform'> & {
  onAction: ActionHandler;
};

export function AppStoreButton(props: AppStoreButtonProps) {
  const href = hrefByPlatform[props.platform];

  const action: PageBuilderLinkAction = {
    action: 'open-href',
    href,
  };

  const svg = {
    'app-store': <SvgAppStore />,
    'google-play': <SvgGooglePlay />,
  }[props.platform];

  return (
    <ActionLink action={action} onAction={props.onAction}>
      {svg}
    </ActionLink>
  );
}
